module.exports = __webpack_public_path__ + "static/media/master-card.9391a6b8.svg";